import React from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { EventAutocomplete } from '../inputs/event-autocomplete';
import { OptionOrOptions } from '../option';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';

type EventAutocompleteProps = React.ComponentProps<typeof EventAutocomplete>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    eventAutocompleteProps?: EventAutocompleteProps;
    searchForCallForService?: boolean;
    cRef?: React.Ref<HTMLInputElement>; // 	https://fettblog.eu/typescript-react-generic-forward-refs/
};

export function FormEventAutocomplete<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const {
        searchForCallForService,
        eventAutocompleteProps,
        ...integratedFormControlProps
    } = props;
    const eventAutocompletePropsMemo = React.useMemo(() => {
        return eventAutocompleteProps ?? {};
    }, [eventAutocompleteProps]);
    const renderViewMode = React.useCallback((value: OptionOrOptions) => {
        if (Array.isArray(value)) {
            if (value.length === 0) return '--';
            return value.map((option) => option.label).join(', ');
        }
        return value.label;
    }, []);
    return (
        <IntegratedFormControl {...integratedFormControlProps} renderViewMode={renderViewMode}>
            {(inputProps) => (
                <EventAutocomplete
                    defaultValue={null}
                    searchForCallForService={searchForCallForService}
                    {...inputProps}
                    {...eventAutocompletePropsMemo}
                />
            )}
        </IntegratedFormControl>
    );
}
